// import React, { useEffect } from "react";
// import Modal from "react-bootstrap/Modal";
// import { API_ENDPOINTS } from "../../../constant/_constant";
// import usePostRequest from "../../../hooks/usePostRequest";
// import moment from "moment";
// import { IconCalendarWeekFilled, IconMailSpark } from "@tabler/icons-react";
// import Lottie from "lottie-react";
// import notfoundData from '../../../assets/not_found.json';
// import {
//   Button,
//   Table,
//   Card,
//   Col,
//   Form,
//   Row,
//   InputGroup,
//   FormText,
//   textarea,
//   Tab,
//   Tabs,
//   Spinner,
//   ButtonGroup,
// } from "react-bootstrap";
// function EmailHistory({ setShow, show, rfq_id }) {
//   const {
//     data: EmailHISTORY_DATA,
//     isLoading: EmailHISTORY_LOADING,
//     postData: fetchEmails,
//   } = usePostRequest(API_ENDPOINTS.EMAIL_HISTORY);

//   useEffect(() => {
//     fetchEmails({ rfq_id: rfq_id });
//   }, []);

//   return (
//     <Modal
//     scrollable={true}
//       show={show}
//       onHide={() => setShow({ show: false })}
//       dialogClassName="modal-90w"
//       size="lg"
//       aria-labelledby="example-custom-modal-styling-title"
//     >
//       <Modal.Header className="gap-2" closeButton>
//         <span className="avatar bg-orange-lt rounded-circle">
//           <IconMailSpark stroke={1.25} />
//         </span>
//         <div>
//           <Modal.Title>Email History</Modal.Title>
//         </div>
//       </Modal.Header>
//       <Modal.Body>

//         {EmailHISTORY_DATA && EmailHISTORY_DATA.data.length > 0 ? (
//           EmailHISTORY_DATA?.data.map((item, index) => {
//             return (
//               <>

//               <div className="mail_wrapper" key={index}>
//               <Row>
//                   <Col md={6}>
//                     <div className="mail_head_item">
//                       <p className="mb-0"><strong>Quote No:</strong> {rfq_id}</p>
//                       <p className="mb-0"><strong>Sent To:</strong> {item?.to_email}</p>
//                     </div>
//                   </Col>
//                   <Col md={6}>
//                   <div className="mail_head_item">
//                     <p className="mb-0 text-end d-flex align-items-center gap-1 justify-content-end"><IconCalendarWeekFilled stroke={1} width={20} /> {moment(item?.latest_date).format("MM/DD/YYYY")}</p>
//                     <p className="mb-0 text-end"><strong>From: </strong> {item?.from_email}</p>
//                   </div>
//                   </Col>
//                 </Row>
//                 <hr/>

//                 <p style={{borderTop:"solid 1px #ddd;"}}
//                     dangerouslySetInnerHTML={{
//                       __html: item?.body || "",
//                     }}
//                   ></p>
//                 <Row>

//                   <div className="table-responsive">

//                     {item?.sku_data && ( <Table bordered >
//                       <thead>
//                         <tr>
//                           <th> Vendor/Partner</th>
//                           <th> SKU ID</th>
//                           <th> SKU Desc</th>
//                           <th> QTY</th>
//                           <th> Unit Cost($)</th>
//                           <th> Total Cost($)</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {item?.sku_data?.map((P, index) => (
//                           <tr key={index}>
//                             <td>{P?.Vendor?.display_name}</td>
//                             <td>{P?.sku_display_name}</td>
//                             <td>{P.description}</td>
//                             <td>{P.quantity}</td>
//                             <td>
//                               {Number(P.customer_price).toLocaleString(
//                                 "en-US",
//                                 {
//                                   minimumFractionDigits: 2,
//                                   maximumFractionDigits: 2,
//                                 }
//                               )}
//                             </td>
//                             <td>
//                               {Number(P.total_price).toLocaleString("en-US", {
//                                 minimumFractionDigits: 2,
//                                 maximumFractionDigits: 2,
//                               })}
//                             </td>
//                           </tr>
//                         ))}
//                         <tr>
//                           <td colSpan={4}></td>
//                           <td>
//                             <strong>SUB TOTAL</strong>
//                           </td>
//                           <td>
//                             <strong>
//                               $
//                               {item.sku_data?.reduce(
//                                   (total, current) =>
//                                     total + Number(current.total_price),
//                                   0
//                                 )
//                                 .toFixed(2)}
//                             </strong>
//                           </td>
//                         </tr>
//                       </tbody>
//                     </Table>)}

//                   </div>
//                 </Row>
//               </div>

//               </>
//             );
//           })
//         ) : (
//            <div className="data_not_available text-center pb-4"> <Lottie animationData={notfoundData}/> <p> No History Available</p>  </div>
//         )}
//       </Modal.Body>
//     </Modal>
//   );
// }

// export default EmailHistory;

import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import Lottie from "lottie-react";
import {
  IconId,
  IconFileText,
  IconCalendarWeekFilled,
} from "@tabler/icons-react";
import {
  Button,
  Table,
  Col,
  Form,
  Row,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";

import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import Stepper from "../../../components/Stepper";
import notfoundData from "../../../assets/not_found.json";
import { trimTrailingZeros } from "../../../utils/_helpers";

function EmailHistoryQuote({
  username,
  rfq_id,
  Quote_No,
  show,
  setShow,
  setIsSuccsessModalOpen,
}) {
  const [currentStep, setCurrentStep] = useState(1);
  const steps = ["Email History", "Send Email"];

  const {
    data: EmailHISTORY_DATA,
    isLoading: EmailHISTORY_LOADING,
    postData: fetchEmails,
  } = usePostRequest(API_ENDPOINTS.EMAIL_HISTORY);

  const { data: EmailUserData, postData: fetchUsers } = usePostRequest(
    API_ENDPOINTS.EMAIL_ALL_USERS
  );

  const { isLoading: sendLoading, postData: SendQuoteEmail } = usePostRequest(
    API_ENDPOINTS.SEND_QUOTE_EMAIL
  );

  const formRef = useRef(null);
  const [errors, setErrors] = useState({ comment: "", to_email: "" });

  const [emailData, setEmailData] = useState({
    rfq_id: rfq_id || "",
    invoice_no: Quote_No || "",
    to_username: username || "",
    to_email: "",
    comment: "",
  });

  useEffect(() => {
    fetchEmails({ rfq_id });
    fetchUsers();
  }, [rfq_id]);

  const validateComment = (val) =>
    val.trim() === "" ? "Comment is required." : "";

  const handleSubmit = (e) => {
    e.preventDefault();

    const commentError = validateComment(emailData.comment);
    const emailError = emailData.to_email ? "" : "Please select a user.";

    if (commentError || emailError) {
      setErrors({ comment: commentError, to_email: emailError });
      return;
    }

    SendQuoteEmail(emailData, onSuccess, onError);
  };

  const onSuccess = () => {
    setIsSuccsessModalOpen({
      show: true,
      title: "Success",
      message: "Email Sent Successfully!",
      btntext: "Close",
    });
    setShow({ show: false });
  };

  const onError = (error) => toast.error(error?.message);

  const handleCancel = () => {
    setEmailData({
      rfq_id,
      invoice_no: Quote_No,
      to_username: username,
      to_email: "",
      comment: "",
    });
    setErrors({ comment: "", to_email: "" });
    setShow({ show: false });
  };

  return (
    <Modal
      scrollable
      show={show}
      onHide={() => setShow({ show: false })}
      dialogClassName="modal-90w"
      size="lg"
    >
      <Modal.Body>
        <Stepper
          steps={steps}
          currentStep={currentStep}
          onTabClick={setCurrentStep}
        />

        <hr className="mb-4" />

        {currentStep === 1 && (
          <>
            {EmailHISTORY_LOADING ? (
              <div className="text-center py-5">
                <Spinner animation="border" />
              </div>
            ) : EmailHISTORY_DATA?.data?.length > 0 ? (
              EmailHISTORY_DATA.data.map((item, index) => (
                <div className="mail_wrapper mb-4" key={index}>
                  <Row>
                    <Col md={6}>
                      <p className="mb-0">
                        <strong>Quote No:</strong> {rfq_id}
                      </p>
                      <p className="mb-0">
                        <strong>Sent To:</strong> {item?.to_email}
                      </p>
                    </Col>
                    <Col md={6} className="text-end">
                      <p className="mb-0 d-flex justify-content-end gap-1">
                        <IconCalendarWeekFilled width={18} />
                        {moment(item?.latest_date).format("MM/DD/YYYY")}
                      </p>
                      <p className="mb-0">
                        <strong>From:</strong> {item?.from_email}
                      </p>
                    </Col>
                  </Row>

                  <hr />

                  <p
                    dangerouslySetInnerHTML={{
                      __html: item?.body || "",
                    }}
                  />

                  {item?.sku_data && (
                    <div className="table-responsive mt-3">
                      <Table bordered>
                        <thead>
                          <tr>
                            <th>Vendor</th>
                            <th>SKU ID</th>
                            <th>Description</th>
                            <th>Qty</th>
                            <th>Unit Cost ($)</th>
                            <th>Total ($)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.sku_data.map((sku, i) => (
                            <tr key={i}>
                              <td>{sku?.Vendor?.display_name}</td>
                              <td>{sku?.sku_display_name}</td>
                              <td>{sku.description}</td>
                              <td>{trimTrailingZeros(sku.quantity)}</td>
                              <td>{Number(sku.customer_price).toFixed(2)}</td>
                              <td>{Number(sku.total_price).toFixed(2)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="data_not_available text-center pb-4">
                <Lottie animationData={notfoundData} />
                <p>No History Available</p>
              </div>
            )}
          </>
        )}

        {currentStep === 2 && (
          <Form onSubmit={handleSubmit} ref={formRef}>
            <Form.Group className="mb-3">
              <Form.Label>OPPORTUNITY ID</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <IconId />
                </InputGroup.Text>
                <Form.Control value={emailData.rfq_id} disabled />
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Select User Email ID</Form.Label>
              <Form.Select
                value={emailData.to_email}
                onChange={(e) =>
                  setEmailData({ ...emailData, to_email: e.target.value })
                }
                isInvalid={!!errors.to_email}
              >
                <option value="">Select User</option>
                {EmailUserData?.data?.map((u, i) => (
                  <option key={i} value={u.email}>
                    {u.email}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.to_email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group>
              <Form.Label>Comments</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <IconFileText />
                </InputGroup.Text>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={emailData.comment}
                  onChange={(e) =>
                    setEmailData({ ...emailData, comment: e.target.value })
                  }
                  isInvalid={!!errors.comment}
                  placeholder="Enter your comment..."
                />
              </InputGroup>
              <Form.Control.Feedback type="invalid">
                {errors.comment}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        )}
      </Modal.Body>

      {currentStep === 2 && (
        <Modal.Footer>
          <Button
            variant="warning"
            onClick={() => formRef.current?.requestSubmit()}
          >
            {sendLoading ? <Spinner size="sm" /> : "Submit"}
          </Button>
          <Button variant="outline-danger" onClick={handleCancel}>
            Cancel
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default EmailHistoryQuote;
